import { render, staticRenderFns } from "./UcAttachmentsPanel.yaml?vue&type=template&id=21df5472&component"
import script from "./UcAttachmentsPanel.yaml?vue&type=script&lang=ts&component"
export * from "./UcAttachmentsPanel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports